import React from 'react';
import { Card } from 'antd';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import ButtonComponent from '@/components/Button';
import './index.scss';
import { ROUTES } from '@/constants';
import { useTranslation } from 'react-i18next';

// type = 'gold' || 'green'
function CardSub({ data, currentID }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  let type = '';
  if (data.id === currentID) {
    type = 'current';
  } else if (data.isGoldPackage) {
    type = 'gold';
  } else if (data.isBestSeller) {
    type = 'green';
  }

  const handleSubscribe = () => {
    navigate(`${ROUTES.SUBSCRIPTIONS.INDEX}/${data.id}/subscribe`);
  };

  // fake gold
  const kclass = type ? `--${type}` : '';
  const renderItemString = ({ label, value }) => (
    <div className="subscriptions-card__item">
      <p className="mb-0">{label}</p>
      <p className="mb-0 subscriptions-card__item__value">{value}</p>
    </div>
  );

  const renderItemCheck = ({ label, value }) => (
    <div className="subscriptions-card__item">
      <p className="mb-0">{label}</p>
      {value ? (
        <span className={`subscriptions-card__item__icon ${kclass}`} />
      ) : (
        <span className="subscriptions-card__item__icon --close" />
      )}
    </div>
  );

  const renew =
    parseFloat(data.period) > 1
      ? `${t('common.every')} ${parseFloat(data.period)} ${t('common.years')}`
      : `${t('common.every')} ${parseFloat(data.period)} ${t('common.year')}`;

  return (
    <div className="subscriptions-card">
      <Card
        className={`subscriptions-card__container ${kclass}`}
        bordered={false}
      >
        {type === 'green' && (
          <div className="subscriptions-card__tag">
            <span className="subscriptions-card__tag__icon" />
            {t('subscription_page.best_seller')}
          </div>
        )}
        {type === 'current' && (
          <div className="subscriptions-card__tag --current">
            <span className="subscriptions-card__tag__icon --current" />
            {t('subscription_page.current_plan')}
          </div>
        )}
        <p className={`subscriptions-card__title mb-0 ${kclass}`}>
          {t(`subscription_page.packages.${data.nameInEnglish}`)}
        </p>
        <p className={`subscriptions-card__price ${kclass}`}>
          {parseFloat(data.price).toLocaleString()} Baht
        </p>
        {renderItemString({
          label: t('subscription_page.renew'),
          value: renew,
        })}
        {renderItemString({
          label: t('subscription_page.number_of_message'),
          value: data.creditNumber?.toLocaleString() || 0,
        })}
        {renderItemString({
          label: t('subscription_page.price_per_message'),
          value: data.pricePerMsg,
        })}
        {renderItemCheck({
          label: t('subscription_page.request_sender_name'),
          value: data.isSenderIdVerification,
        })}
        {renderItemCheck({
          label: t('subscription_page.send_sms_via_api'),
          value: data.isApiAccess,
        })}
        <ButtonComponent
          type="primary"
          className="subscriptions-card__btn"
          onClick={handleSubscribe}
        >
          <span className="subscriptions-card__btn__refresh" />
          {type === 'current'
            ? t('subscription_page.renew')
            : t('subscription_page.subcribe_now')}
        </ButtonComponent>
      </Card>
    </div>
  );
}

CardSub.propTypes = {
  data: PropTypes.object,
  currentID: PropTypes.string,
};

export default CardSub;
